export function isJsonString(str: string) {
  try {
    if (typeof str !== 'string') {
      return false
    }
    JSON.parse(str)
  } catch (e) {
    console.error('isJsonString: invalid JSON', e)
    return false
  }
  return true
}

export function parseJson(str: string) {
  try {
    return JSON.parse(str)
  } catch (e) {
    console.error('parseJson: failed to parse', e)
    return null
  }
}

export function compareJson(a: any, b: any) {
  return JSON.stringify(a) === JSON.stringify(b)
}
